import { RouteRecordRaw } from 'vue-router'
import { authGuard } from '../guards/authGuard.js'
import AdminLayout from '@/shared/layouts/AdminLayout.vue'

export const invoiceRoutes: RouteRecordRaw = {
  path: '/invoices',
  component: AdminLayout,
  beforeEnter: authGuard,
  meta: {
    requiresAuth: true,
    requiredRoles: ['editor']
  },
  children: [
    {
      path: '',
      name: 'invoices',
      component: () => import('@/features/invoices/components/InvoicePage.vue'),
      meta: {
        title: 'Invoices',
        subtitle: 'Manage your invoices',
        description: 'View and manage your invoices',
        requiresAuth: true,
        requiredRoles: ['editor']
      }
    }
  ]
} 